import _ from 'lodash';

import * as SlideApi from './SlideApi';
import * as SlideSelectors from "./SlideSelectors";
import * as ElementActions from '../elements/ElementActions';

import SlideConstants from './SlideConstants';

const receivedSlide = (slide) => ({
    type: SlideConstants.SLIDE_RECEIVED,
    payload: {
        id: slide.id,
        story_id: slide.story_id,
        position: slide.position,
        slide_type: slide.type,
        data: slide.data,
    }
});

const removedSlide = (slideId) => ({
    type: SlideConstants.SLIDE_REMOVED,
    payload: {
        id: slideId,
    }
});

const movedSlide = (slideId, position) => ({
    type: SlideConstants.SLIDE_MOVED,
    payload: {
        id: slideId,
        position: position
    }
});

export const slideChanging = (slideId, changes) => ({
    type: SlideConstants.SLIDE_CHANGING,
    payload: {
        id: slideId,
        changes: changes,
    }
});

export function slideChanged(slideId) {
    return function (dispatch, getState) {
        const slide = getState().slides[slideId];

        if (! slide) {
            return;
        }

        return SlideApi.editSlide(
            slideId,
            JSON.stringify(slide.data)
        );
    }
}

export function listSlides(storyId) {
    return function (dispatch) {
        return SlideApi.listSlides(storyId).then(response => {
            _.map(response, slide => {
                dispatch(receivedSlide(slide));
                dispatch(ElementActions.receivedElements(slide.elements));
            });

            return response;
        });
    };
}

export function getSlide(slideId) {
    return function (dispatch) {
        return SlideApi.getSlide(slideId).then(slide => {
            dispatch(receivedSlide(slide));
            dispatch(ElementActions.receivedElements(slide.elements));

            return slide;
        });
    };
}

export function createSlide(storyId, type = null) {
    return function (dispatch) {
        return SlideApi.createSlide(storyId, type).then(response => {
            return dispatch(getSlide(response.id));
        });
    };
}

export function editSlide(slideId, data) {
    return function (dispatch, getState) {
        return SlideApi.editSlide(slideId, data).then(() => {
            const slide = SlideSelectors.findById(getState(), slideId);

            dispatch(listSlides(slide.story_id));
        });
    }
}

export function removeSlide(slideId) {
    return function (dispatch) {
        dispatch(movedSlide(slideId, 999));
        dispatch(removedSlide(slideId));

        return SlideApi.removeSlide(slideId);
    }
}

export function moveSlide(slideId, position) {
    return function (dispatch, getState) {

        if (position < 1) {
            return;
        }

        const slide = SlideSelectors.findById(getState(), slideId);
        const slides = SlideSelectors.filterByStoryId(getState(), slide.story_id);

        if (position > slides.length) {
            return;
        }

        dispatch(movedSlide(slideId, position));

        return SlideApi.moveSlide(slideId, position);
    }
}

export function duplicateSlide(slideId) {
    return function (dispatch) {
        return SlideApi.duplicate(slideId).then(response => {
            return dispatch(getSlide(response.id)).then(response => {
                dispatch(movedSlide(response.id, response.position)); // quickly move it!
                dispatch(listSlides(response.story_id));

                return response;
            });
        });
    }
}
